<template>
   <div class="simple-map  info-windows" style='height:300px;width:100%' >

    <google-map id="map" ref="Map" :center="mapcenter"  :zoom.sync="zoom" mapTypeId="hybrid" :tilt="45" >
      <google-map-marker
          v-for="(marker, index) in markers"
          :key="index"
          :title="marker.title"
          :position="marker.position"
          @click="toggleInfoWindow(marker)"
          @rightclick="setPanorama(marker.position)"
      />
      <google-map-polyline v-if="this.path"
          :path="path"
          :draggable="false"
          :strokeWeight="3"
      />
       <google-map-infowindow
              v-for="(marker, index) in markers"
              :key="`info-window-${index}`"
              :position="marker.position"
              :show.sync="showInfo"
              :options="{maxWidth: 300}"
              @info-window-clicked="infoClicked($event, marker)"
      >
        <div>
          <h4>{{marker.title}}</h4>
          <p>{{marker.description}}</p>
          <p>Click droit sur le marqueur pour la streetview</p>
        </div>
      </google-map-infowindow>

    </google-map>
  </div>

</template>

<script>





export default {
  name: "GoogleMapModule",
  props: {
    markers :Array,
    mapcenter : Object,
    streetviewOn : {
      type : Boolean,
      default : false
    },
    zoom : {
      type : Number,
      default : 4.5
    }
  },


  data() {
    return {
      showInfo: false,
      path: null, // dessinne un polygone
      pathexample : [
        {
         lat: 48.8534,
              lng: 2.3488
        },
        {
           lat: 48.80000,
              lng: 2.3000
        },
        {
           lat: 48.8600,
              lng: 2.35000
        }
      ]
    }
  },
  mounted() {

  },
  methods: {
    panToMarker(pos) {
      this.$refs.Map.panTo(pos)
    },
    setPanorama(pos) {
      this.$refs.Map.setStreetView(pos, {}, (err, data) => {
        console.log(err)
        console.log(data)
      })
    },
      toggleInfoWindow() {
      //this.infoWIndowContext = context
      this.showInfo = true
    },
    infoClicked(context) {
      console.log(context)
    }
  }

}
</script>